// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from settings.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function SettingsIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M13 10a3 3 0 1 1-2.835 3.985l-.048.008L10 14H1a1 1 0 0 1-.117-1.993L1 12h9c.057 0 .112.005.166.014A3 3 0 0 1 13 10Zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM3 0c1.312 0 2.427.842 2.835 2.015l.048-.008L6 2h9a1 1 0 0 1 .117 1.993L15 4H6c-.057 0-.112-.005-.166-.014A3 3 0 1 1 3 0Zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
      />
    </svg>
  );
}
